import React from 'react';
import { default as OrderSearch } from './edit';

function Search() {
    return <OrderSearch readonly={true} />;
}

export default Search;
